<script>
  import options from './AttachmentsEditor.options'
  export default options
</script>

<template>
  
  <article class="kb-community-attachments-editor">
    <div class="kb-community-attachments-editor__files" v-if="files && files.length > 0">
      <template v-for="file, index in files" :key="index">
        <div class="kb-community-attachments-editor__files-content-wrapper">
          <div class="kb-community-attachments-editor__files-content-wrapper-left">
            <div v-if="isDocument(file)">
              <div v-html="getDocumentIcon(file)"> </div>
            </div>
            <figure v-else class="kb-community-attachments-editor__files-image kb-image-module">
              <div class="kb-image-module__image-container">
                <picture class="kb-image-module__image">
                  <img :src="file.url" alt="gallery image" />
                </picture>
              </div>
            </figure>
          </div>
          <div class="kb-create-gallery__files-content-wrapper-right">
            <div class="kb-create-gallery__files-details-wrapper">
              <p :id="'kb-create-gallery__files-details-wrapper-file-name'+index">{{ file.filename }}</p>
              <p>{{ getLabel('fileSizeLabel') }}: {{ formatFileSize(file.size) }}</p>
            </div>
            <button class="kb-button kb-button--full-color-spot kb-create-gallery__files-delete-button"
              :aria-describedby="'kb-create-gallery__files-details-wrapper-file-name'+index"
              v-on:click="() => removeFile(file)">{{
                getLabel('fileButtonRemove') }}</button>
          </div>
        </div>
      </template>
    </div>
  
    <label 
      class="kb-community-attachments-editor__file-upload FormFileUpload"             
      :class="{'kb-community-attachments-editor__file-upload--validation-error': isValidationError}"
      for="uploadFile">
      <input
        class="kb-community-attachments-editor__file-upload-input FormFileUpload__Input"
        id="uploadFile"
        type="file"
        :accept="acceptedFileTypes"
        v-on:change="addFile"
      />
      <div class="kb-community-attachments-editor__file-upload-svg">
        <svg
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity=".4" fill="#3C3C3C">
            <path
              d="m20.024 13.05.967-.405-.206-.481c-.84-2.002-.617-4.14.596-5.683 1.214-1.542 3.095-2.264 5.32-2.093l-1.49 1.438.73.75 2.016-1.961a1.008 1.008 0 0 0 0-1.44l-2.016-1.961-.73.75 1.396 1.357c-2.505-.133-4.674.757-6.049 2.518-1.451 1.856-1.72 4.375-.736 6.72l.203.49ZM18.141 24.419v1.046h-5.93v-1.046H.699v2.965a1.214 1.214 0 0 0 1.221 1.22h26.163a1.22 1.22 0 0 0 1.22-1.22v-2.965H18.142Zm10.116 2.965a.174.174 0 0 1-.174.174H1.92a.178.178 0 0 1-.125-.052.175.175 0 0 1-.05-.122v-1.919h9.42v1.047h8.023v-1.047h9.07v1.919ZM4.886 21.977H2.793V9.593a.174.174 0 0 1 .174-.174h14.128V8.372H2.967a1.22 1.22 0 0 0-1.22 1.221v13.43h3.139v-1.046Z"
            />
            <path
              d="M28.256 23.023V9.593a1.22 1.22 0 0 0-1.22-1.22h-4.013v1.046h4.012a.174.174 0 0 1 .174.174v13.43h1.047Z"
            />
          </g>
        </svg>
      </div>
      <div class="kb-community-attachments-editor__file-upload-text-wrapper">
        <p class="kb-community-attachments-editor__file-upload-text">{{ getLabel('uploadTitle') }}</p>
        <small class="kb-community-attachments-editor__file-upload-format-types">{{ getLabel('uploadFormats') }}​</small>
      </div>
    </label>

    <div aria-live="assertive">
      <p v-if="isValidationError && getLabel('fileErrorMessage', true)"
          role="alert"
          class="kb-forms Form__Element__ValidationError Form__Element__ValidationError--image-upload">
          {{ getLabel('fileErrorMessage') }} 
      </p>
    </div>
    
  </article>

</template>